import {onBeforeMount, ref} from "vue";
import type {GetContextMenuItems, GetContextMenuItemsParams, GetMainMenuItems, GetMainMenuItemsParams} from "ag-grid-enterprise";
import Translator from "@/utils/common/Translator.ts";
import AgShowFieldInfo from "@/components/EditView/AgShowFieldInfo.vue";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import AgCopyHeader from "@/components/EditView/AgCopyHeader.vue";


export default class AgShowFieldInfoContextMenu {
  public getMainMenuItems = ref<GetMainMenuItems>();
  public getContextMenuItems = ref<GetContextMenuItems>();

  constructor() {
    this.initAgGridContextMenu()
  }

  private initAgGridContextMenu() {
    onBeforeMount(() => {
      this.getMainMenuItems.value = (params: GetMainMenuItemsParams) => {
        if (!useNamaFlagsStore().showFieldInfoActive)
          return [...(params.defaultItems || []),"separator",this.copyColumnHeader(params)];
        return [
          ...params.defaultItems,
          "separator",
          this.copyColumnHeader(params),
          this.fieldInfoMenuItem(params),
        ];
      };
      this.getContextMenuItems.value = (params: GetContextMenuItemsParams) => {
        if (!useNamaFlagsStore().showFieldInfoActive)
          return [...(params.defaultItems || []), "separator", this.copyColumnHeader(params)];
        return [
          ...(params.defaultItems || []),
          "separator",
          this.copyColumnHeader(params),
          this.fieldInfoMenuItem(params),
        ];
      };
    });
  }

  private fieldInfoMenuItem(params: GetContextMenuItemsParams | GetMainMenuItemsParams) {
    return {
      name: Translator.translateId("fieldInfo"),
      menuItem: AgShowFieldInfo,
      menuItemParams: {
        column: params.column
      },
    };
  }

  private copyColumnHeader(params: GetContextMenuItemsParams | GetMainMenuItemsParams) {
    return {
      name: Translator.translateId("copyHeader"),
      menuItem: AgCopyHeader,
      menuItemParams: {
        column: params.column
      },
    };
  }
}
